/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Transition from '@ember/routing/transition';

export default class BillingSummaryIndexRoute extends Route {
  @service declare customerService: $TSFixMe;

  setupController(controller: $TSFixMe, model: $TSFixMe, transition: Transition) {
    super.setupController(controller, model, transition);
    if (controller.oepm) {
      controller._openEditPlanModal();
    }
  }

  resetController(controller: $TSFixMe, isExiting: boolean, _: Transition) {
    if (isExiting) {
      controller.setProperties({
        esChoiceConfirmation: false,
      });
    }
  }
}
